import apiService from '../api/apiService';
import { AxiosResponse } from 'axios';

export interface MerchantReview {
  id: string;
  productId: string | null;
  productName: string | null;
  customerName: string | null;
  rating: number | null;
  headline: string | null;
  review: string | null;
  media: string[] | null;
  createdAt: string | null;
}

export interface MerchantReviewsResponse {
  status: number;
  message: string | null;
  errors: string[] | null;
  data: {
    data: MerchantReview[];
    totalPages: number;
    totalElements: number;
    last: boolean;
    first: boolean;
    hasNext: boolean;
    hasPrevious: boolean;
    numberOfElements: number;
  };
}

const ReviewController = {
  /**
   * Get reviews customers left across the logged-in merchant's products.
   */
  getMerchantReviews: (page = 0, size = 50): Promise<AxiosResponse<MerchantReviewsResponse>> =>
    apiService.get<MerchantReviewsResponse>(`/review-ratings/merchant?page=${page}&size=${size}`),
};

export default ReviewController;
